import { Language } from "@faire/web-api--source/indigofair/languages/Language";
import flow from "lodash/flow";

export const getZendeskLocale = (userLanguage: keyof typeof Language) => {
  switch (userLanguage) {
    case Language.ITA:
      return "it";
    case Language.SPA:
      return "es-es";
    case Language.FRA:
      return "fr-fr";
    case Language.DEU:
      return "de";
    case Language.SWE:
      return "sv-se";
    case Language.POR:
      return "pt-pt";
    case Language.NLD:
      return "nl-nl";
    case Language.DAN:
      return "da-dk";
    default:
      return "en-us";
  }
};

const NON_BREAKING_SPACE_CHAR_CODE = 160;
type SanitizePatterns = { [pattern: string]: string };

// Replace all non breaking spaces (i.e '&nbsp;') with space (i.e '&#32;')
const replaceAllNonBreakingSpaces = (text: string): string => {
  return text
    .split(String.fromCharCode(NON_BREAKING_SPACE_CHAR_CODE))
    .join(" ");
};

// Replaces all occurrences based on a set of patterns
const replaceByPatterns =
  (patterns: SanitizePatterns) =>
  (text: string): string => {
    let formattedText = text;
    for (const [target, formatted] of Object.entries(patterns)) {
      formattedText = formattedText.split(target).join(formatted);
    }
    return formattedText;
  };

export const getSanitizeArticleFunc = (sanitizePatterns: SanitizePatterns) => {
  return flow(replaceAllNonBreakingSpaces, replaceByPatterns(sanitizePatterns));
};
